import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/appointments`;

export const appointmentsAPI = {
  create: async (appointmentData) => {
    try {
      const response = await axios.post(API, appointmentData);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to create appointment:', error);
      return { 
        success: false, 
        error: error.response?.data?.detail || 'Не удалось создать запись. Попробуйте позже.' 
      };
    }
  },

  getAll: async () => {
    try {
      const response = await axios.get(API);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to fetch appointments:', error);
      return { 
        success: false, 
        error: error.response?.data?.detail || 'Не удалось получить записи.' 
      };
    }
  },

  getById: async (id) => {
    try {
      const response = await axios.get(`${API}/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to fetch appointment:', error);
      return { 
        success: false, 
        error: error.response?.data?.detail || 'Не удалось найти запись.' 
      };
    }
  }
};
